import { Component, OnChanges, OnInit, Input, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { HelperService } from '../service/helper/helper.service';
import { compileBaseDefFromMetadata } from '@angular/compiler';
import { Router } from '@angular/router';
import { ModalComponent } from '../modal/modal.component';
import { DecimalPipe } from '@angular/common'
import Swal from 'sweetalert2';


@Component({
  selector: 'app-transfer',
  inputs: ['data'],
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.css']
})
export class TransferComponent implements OnInit {

  data: any = {};
  change: any[];
  // @Input() data: string;
  constructor(public num: DecimalPipe, public dialog: MatDialog,public helper: HelperService, public router: Router) { }

  ngOnInit() {
    this.helper.receipt = '';
  }

  route(linkName) {
    const link = ['/' + linkName];
    this.router.navigate(link);
  }

  // /^[1-9]\d*(\.\d+)?$/.test(updatedData)
  checkData(updatedData){
    if(/^[0-9][\.\d]*(,+\d+)?$/.test(updatedData) || updatedData == ""){
      if(updatedData.includes(".")){
        this.change = updatedData.split(".",2);
        if(this.change[1].length > 8){
          Swal.fire({
            title: 'Error: ',
            text: 'Only 8 decimal places are allowed',
            type: 'error',
            confirmButtonText: 'Ok',
          }).then(() => {
            // this.data.value = '';
            var n =  updatedData.slice(0,-1)
            this.data.value = n;
          })
        }
        else{
          this.data.value =  updatedData
        }
      }
      else{
        this.data.value = updatedData

      }
    }
    else{
      // alert()
      Swal.fire({
        title: 'Error: ',
        text: 'Only numerical values are allowed',
        type: 'error',
        confirmButtonText: 'Ok',
      }).then(() => {
        var n =  updatedData.slice(0,-1)
        this.data.value = n;
      })
    }
  }


  // transformInput(data){
  //   return this.num.transform(data,'1.2-2')
  // }


  sendNit() {
    console.log(this.data.to);
    console.log(this.data.value);
    if(!this.data.to || !this.data.value || this.data.value == 0){
      Swal.fire({
        title: 'Error: ',
        text: 'Please enter valid values',
        type: 'error',
        confirmButtonText: 'Ok',
      })
    }
    else{
      if(this.helper.web3.utils.isAddress(this.data.to)){
        // console.log(this.helper.currentAccount.balance this.data.value)
        if(this.helper.currentAccount.balance >= parseFloat(this.data.value)){

          this.helper.sendNit(this.data.to, this.data.value, (done) => {
            if (done) {
              this.data.to = '';
              this.data.value = '';
            }
          });
        }
        else{
          Swal.fire({
            title: 'Error: ',
            text: 'Insufficient Balance',
            type: 'error',
            confirmButtonText: 'Ok',
          })
        }
      }
      else{
        Swal.fire({
          title: 'Error: ',
          text: 'Please enter valid NIT address',
          type: 'error',
          confirmButtonText: 'Ok',
        })
      }
    }

  }

  goToLink(link) {
    window.open("http://3.18.174.148/#/tx/" + link, "_blank");

  }
  backToDashboard() {
    this.router.navigate(['dashboard'])
  }


//   openDialog() {

//     const dialogConfig = new MatDialogConfig();

//     dialogConfig.disableClose = false;
//     dialogConfig.autoFocus = true;

//     dialogConfig.data = {
//       id: 1,
//       title: 'Angular For Beginners'
//     };
//     dialogConfig.minWidth='300px'
//     // this.dialog.dialogContainer = {

//     // }

//     dialogConfig.position = {
//       top:'68px',
//       right: '0',

//     };

//     this.dialog.open(ModalComponent, dialogConfig);
// }
openDialog() {

  const dialogConfig = new MatDialogConfig();

  dialogConfig.disableClose = false;
  dialogConfig.autoFocus = true;

  dialogConfig.data = {
    id: 1,
    title: 'Angular For Beginners'
  };
  dialogConfig.minWidth='300px'
  // this.dialog.dialogContainer = {

  // }

  dialogConfig.position = {
    top:'67px',
    right: '0',

  };

  this.dialog.open(ModalComponent, dialogConfig);
}
}
